import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CustomJwtInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let curentLogin = JSON.parse(localStorage.getItem('curentLogin'));
        if (curentLogin && curentLogin.token) {
            request = request.clone({
                setHeaders: { Authorization: 'Bearer ' + curentLogin.token }
            });
        }

        return next.handle(request);
    }
}